import React from 'react';
import Plot from 'react-plotly.js';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

const BarChartComponent = ({ data = [], dataNamesLabel, dataValuesLabel, isDataAvailable,
    secondDataValuesLabel, legendNames, width = '100%', height = '100%' }) => {

    const insertLineBreak = (label) => {
        if (typeof label !== "string" || label.length <= 25) return label;

        const middle = Math.floor(label.length / 2);
        const spaceBefore = label.lastIndexOf(' ', middle);
        const spaceAfter = label.indexOf(' ', middle);

        let breakIndex;

        // Find the space closest to the centre of the string
        if (spaceBefore === -1 && spaceAfter === -1) {
            breakIndex = middle;
        } else if (spaceBefore === -1) {
            breakIndex = spaceAfter;
        } else if (spaceAfter === -1) {
            breakIndex = spaceBefore;
        } else {
            breakIndex = (middle - spaceBefore < spaceAfter - middle) ? spaceBefore : spaceAfter;
        }

        return label.slice(0, breakIndex) + "<br>" + label.slice(breakIndex + 1);
    }

    let plotData = [{
        x: data.map(d => insertLineBreak(d[dataNamesLabel])),
        y: data.map(d => d[dataValuesLabel]),
        type: 'bar',
        name: legendNames?.[dataValuesLabel],
        marker: { color: 'rgb(207, 119, 255)' }
    }];
    if (secondDataValuesLabel) {
        plotData.push({
            x: data.map(d => insertLineBreak(d[dataNamesLabel])),
            y: data.map(d => d[secondDataValuesLabel]),
            type: 'bar',
            name: legendNames?.[secondDataValuesLabel],
            marker: { color: 'rgb(99, 132, 255)' }
        })
    }

    return isDataAvailable
        ? data?.length > 0 ?
            <div>
                <div style={{ width, height, zIndex: "1", minHeight: '30em' }}>
                    <Plot
                        data={plotData}
                        layout={{
                            barmode: 'stack',
                            autosize: true,
                            margin: { l: 50, r: 50, b: 120, t: 50, pad: 4 },
                            xaxis: { tickangle: -45 },
                            hoverlabel: { bgcolor: 'rgb(255, 255, 255)' },
                            legend: { orientation: 'h', y: 1.1 },
                        }}
                        useResizeHandler={true}
                    />
                </div>
            </div>
            : <Alert variant="warning">Aucune donnée à afficher</Alert>
        : <Alert variant="danger">Donnée non disponible</Alert>;
}

BarChartComponent.propTypes = {
    data: PropTypes.array.isRequired,
    dataNamesLabel: PropTypes.string.isRequired,
    dataValuesLabel: PropTypes.string.isRequired,
    isDataAvailable: PropTypes.bool.isRequired,
    secondDataValuesLabel: PropTypes.string,
    legend: PropTypes.object,
    width: PropTypes.string,
    height: PropTypes.string,
};

export default BarChartComponent;